export default "<template>\n\n  <KBreadcrumbs\n    showSingleItem\n    :items=\"[{ text: 'Home', link: null }]\"\n  />\n\n</template>\n";